import React from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  const bare = pathname.startsWith("/admin") || pathname.startsWith("/staff");
  return (
    <div className="App flex flex-col min-h-screen">
      {!bare && <Navbar />}
      <main className="flex-1">{children}</main>
      {!bare && <Footer />}
    </div>
  );
}
